export function Modal({ children, visible, setVisible }) {

    return (
        <div className={`h-screen w-screen fixed z-50 top-0 ${!visible ? "hidden" : ""} flex justify-center items-center bg-slate-800/80`} 
            onClick={()=>setVisible(false)}
        >
            {children}
        </div>
    )
}